import React, { PureComponent } from "react";
import axios from "axios";
import Header from "../components/Header";
import Modal from "../components/Modal";
import Loader from "../components/Loader";
import Alert from "../components/Alert";
import { server, config, checkAccess } from "../env";
import apiRequests from "../tools/api";

export default class Settings extends PureComponent {
  state = {
    access: {},
    // update email
    updateEmailLoader: "",
    updateEmailMessage: "",
    isOtpSent: false,

    // update password
    updatePasswordLoader: "",
    updatePasswordMessage: "",

    // two fa and account
    twoFA: false,
    twoFALoader: "",
    twoFAMessage: "",
    account: false,
    accountLoader: "",
    accountMessage: "",
  };

  componentDidMount = async () => {
    document.title = "Account Settings - Prixies.gg";
    await axios
      .get(server + "/v1/auth/access", config)
      .then((rsp) => {
        this.setState({
          twoFA: rsp.data.payload.is_2fa,
          account: rsp.data.payload.is_active,
        });
      })
      .catch((err) => {
        checkAccess(err);
      });

    this.setState({
      access: await apiRequests.getAccess(),
    });
  };

  updateEmail = async (e) => {
    e.preventDefault();
    this.setState({
      updateEmailLoader: <Loader />,
    });

    var params = Array.from(e.target.elements)
      .filter((el) => el.name)
      .reduce((a, b) => ({ ...a, [b.name]: b.value }), {});

    var url;
    if (this.state.isOtpSent) {
      url = "/v1/auth/update-email";
    } else {
      url = "/v1/auth/update-email-verification";
    }

    await axios
      .post(server + url, params, config)
      .then((rsp) => {
        if (!this.state.isOtpSent) {
          this.setState({
            isOtpSent: true,
          });
        }
        // else {
        //   Cookies.remove("token");
        //   window.location.href = "/";
        // }
        this.setState({
          updateEmailMessage: (
            <Alert className="success" message={rsp.data.detail} />
          ),
          updateEmailLoader: "",
        });
      })
      .catch((err) => {
        checkAccess(err);
        if (err.response) {
          this.setState({
            updateEmailMessage: (
              <Alert className="danger" message={err.response.data.detail} />
            ),
          });
        }
        this.setState({
          updateEmailLoader: "",
        });
      });
  };

  updatePassword = async (e) => {
    e.preventDefault();
    this.setState({
      updatePasswordLoader: <Loader />,
    });

    if (e.target.new_password.value !== e.target.cnf_password.value) {
      this.setState({
        updatePasswordMessage: (
          <Alert className="danger" message="passwords didn't matched" />
        ),
        updatePasswordLoader: "",
      });
      return;
    }

    const params = {
      old_password: e.target.password.value,
      new_password: e.target.new_password.value,
    };

    await axios
      .post(server + "/v1/auth/update-password", params, config)
      .then(async (rsp) => {
        this.setState({
          updatePasswordLoader: "",
          updatePasswordMessage: (
            <Alert className="success" message={rsp.data.detail} />
          ),
        });
      })
      .catch((err) => {
        console.log(err);
        checkAccess(err);
        if (err.response) {
          this.setState({
            updatePasswordMessage: (
              <Alert className="danger" message={err.response.data.detail} />
            ),
          });
        }
        this.setState({
          updatePasswordLoader: "",
        });
      });
  };

  twoFA = async () => {
    this.setState({
      twoFALoader: <Loader />,
      twoFAMessage: "",
    });

    await axios
      .post(server + "/v1/auth/two-factor/" + this.state.twoFA, {}, config)
      .then((rsp) => {
        this.setState({
          twoFAMessage: <Alert className="success" message={rsp.data.detail} />,
          twoFALoader: "",
        });
      })
      .catch((err) => {
        checkAccess(err);
        if (err.response) {
          this.setState({
            twoFAMessage: (
              <Alert className="danger" message={err.response.data.detail} />
            ),
          });
        }
        this.setState({
          twoFALoader: "",
        });
      });
  };
  account = async () => {
    this.setState({
      accountLoader: <Loader />,
    });

    await axios
      .post(server + "/v1/auth/two-factor/" + this.state.account, {}, config)
      .then((rsp) => {
        this.setState({
          accountMessage: (
            <Alert className="success" message={rsp.data.detail} />
          ),
          accountLoader: "",
        });
      })
      .catch((err) => {
        checkAccess(err);
        if (err.response) {
          this.setState({
            accountMessage: (
              <Alert className="danger" message={err.response.data.detail} />
            ),
          });
        }
        this.setState({
          accountLoader: "",
        });
      });
  };

  regenerateKey = async () => {
    this.setState({
      keyLoader: <Loader />,
    });
    this.setState({
      access: await apiRequests.regenerateKey(),
    });
    this.setState({
      keyLoader: "",
    });
  };

  render() {
    const { isOtpSent } = this.state;
    const { updateEmailMessage, updateEmailLoader } = this.state;
    const { updatePasswordMessage, updatePasswordLoader } = this.state;
    const { twoFA, account } = this.state;
    const { twoFALoader, twoFAMessage } = this.state;
    const { accountLoader, accountMessage, access, keyLoader } = this.state;

    return (
      <div className="main-content">
        <Header pretitle="Account" title="Security Settings" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-header-title">Change Email</h4>
                </div>
                <div className="card-body">
                  <form onSubmit={this.updateEmail}>
                    {updateEmailMessage}
                    <div className="form-group">
                      <label>New Email</label>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        className="form-control"
                        required
                      />
                    </div>
                    {isOtpSent ? (
                      <div className="form-group">
                        <label htmlFor="otp">OTP</label>
                        <input
                          type="number"
                          name="otp"
                          id="otp"
                          className="form-control"
                          required
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="form-group float-right mb-n1">
                      <button type="submit" className="btn btn-primary w-100">
                        {isOtpSent ? "Update Email" : "Verify Email"}{" "}
                        {updateEmailLoader}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-header-title">Change Password</h4>
                </div>
                <div className="card-body">
                  <form onSubmit={this.updatePassword}>
                    {updatePasswordMessage}
                    <div className="form-group">
                      <label>Old Password</label>
                      <input
                        type="password"
                        name="password"
                        id="password"
                        className="form-control"
                        autoFocus
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>New Password</label>
                      <input
                        type="password"
                        name="newPassword"
                        id="new_password"
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Confirm Password</label>
                      <input
                        type="password"
                        name="cnf_password"
                        id="cnfPassword"
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="form-group float-right mb-n1">
                      <button type="submit" className="btn btn-primary w-100">
                        Change Password {updatePasswordLoader}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* 2FA */}
            <div className="col-md-6">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-header-title">
                    Two-Factor Authentication
                  </h4>
                </div>
                <div className="card-body">
                  <form>
                    <div className="form-group">
                      <div className="custom-control custom-switch">
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={twoFA}
                            onChange={() =>
                              this.setState({
                                twoFA: twoFA ? false : true,
                              })
                            }
                            data-bs-toggle="modal"
                            data-bs-target="#twoFA"
                          />
                          <label className="form-check-label" htmlFor="2fa">
                            Disable
                          </label>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* Deactivate Account */}
            <div className="col-md-6">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-header-title">Deactivate Account</h4>
                </div>
                <div className="card-body">
                  <form>
                    <div className="form-group">
                      <div className="custom-control custom-switch">
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={account}
                            onChange={() =>
                              this.setState({
                                account: account ? false : true,
                              })
                            }
                            data-bs-toggle="modal"
                            data-bs-target="#account"
                          />
                          <label className="form-check-label" htmlFor="2fa">
                            Active
                          </label>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* Regenerate API Key */}
            {access.isReseller && (
              <div className="col-md-6">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-header-title">API KEY</h4>
                  </div>
                  <div className="card-body">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        value={this.state.access?.apiKey}
                      />
                    </div>
                    <div className="form-group">
                      <button
                        className="btn btn-primary w-100"
                        onClick={this.regenerateKey}
                      >
                        Regenerate API Key {keyLoader}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* Modals */}
        {/* Two Factor Authentication */}
        <Modal id="twoFA" title="Delete Blog" style={{ zIndex: 1200 }}>
          <div className="modal-body  text-center">
            {twoFAMessage}
            <h3>
              Are you sure you want to {twoFA ? "enable" : "disable"} Two-Factor
              Authentication?
            </h3>
            <div className="form-group mt-4">
              <button className="btn btn-primary m-2" data-bs-dismiss="modal">
                Go back
              </button>
              <button className="btn btn-danger" onClick={this.twoFA}>
                Continue {twoFALoader}
              </button>
            </div>
          </div>
        </Modal>

        {/* Account Settings */}
        <Modal id="account" title="Delete Blog" style={{ zIndex: 1200 }}>
          <div className="modal-body  text-center">
            {accountMessage}
            <h3>Are you sure you want to deactivate account?</h3>
            <div className="form-group mt-4">
              <button className="btn btn-primary m-2" data-bs-dismiss="modal">
                Go back
              </button>
              <button className="btn btn-danger" onClick={this.twoFA}>
                Continue {accountLoader}
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
